module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/bamboo-delicacies/"},"excerpt":"If you love bamboo shoots as much as I do, join me on my next expedition to find the most delicate shoots in the world. I’ll let past…","timeToRead":1,"frontmatter":{"title":"Bamboo Delicacies","tags":["bamboo","delicacies","mammals","pandas"]}}}]}},"pathContext":{"tag":"pandas"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-pandas.json
// module id = 769
// module chunks = 160144285498051